// Traducciones para FirmaElectronicaConfianzaPage
export const signatureTranslations = {
  es: {
    'hero-title': 'Firma electrónica en BlueCMR',
    'hero-subtitle': 'La firma electrónica es un elemento esencial en la validez jurídica de los documentos de transporte digitales. BlueCMR implementa mecanismos de firma electrónica avanzada, conforme al Reglamento eIDAS, que permiten vincular de forma inequívoca identidad, documento y consentimiento.',
    'intro': 'Esta página describe qué tipo de firma utiliza BlueCMR, cómo se realiza el proceso de firma y qué garantías técnicas y jurídicas se aplican.',
    'legal-title': 'Marco legal de la firma electrónica',
    'legal-intro': 'El Reglamento eIDAS (UE 910/2014) establece tres tipos de firma electrónica:',
    'simple-signature': 'Firma electrónica simple',
    'advanced-signature': 'Firma electrónica avanzada',
    'qualified-signature': 'Firma electrónica cualificada',
    'bluecmr-uses': 'BlueCMR utiliza firma electrónica avanzada',
    'bluecmr-uses-desc': 'Adecuada para documentos de transporte digitales conforme a eIDAS, al Protocolo eCMR y a la normativa española aplicable.',
    'modalities-title': 'Modalidades de firma en BlueCMR',
    'modalities-intro': 'BlueCMR permite firmar documentos de transporte de distintas formas, adaptándose al contexto operativo del transporte por carretera.',
    'device-signature': 'Firma en el propio dispositivo',
    'device-signature-desc': 'El firmante puede realizar la firma directamente en su dispositivo, sin intermediarios, quedando la firma vinculada al documento y a su identidad.',
    'third-party-signature': 'Firma enviada a terceros',
    'third-party-signature-desc': 'Un documento puede enviarse para firma a:',
    'drivers': 'Conductores',
    'second-drivers': 'Segundos conductores',
    'transport-operators': 'Operadores de transporte',
    'consignees': 'Destinatarios u otros intervinientes',
    'no-account-needed': 'La firma puede completarse sin necesidad de crear una cuenta en la plataforma.',
    'channels-title': 'Canales de envío y control de autorizaciones',
    'channels-intro': 'Cuando un documento se envía para firma, BlueCMR genera un enlace seguro que puede distribuirse a través de distintos canales:',
    'email': 'Correo electrónico',
    'sms': 'SMS',
    'qr-code': 'Código QR',
    'whatsapp': 'WhatsApp',
    'link-features': 'Cada enlace de firma:',
    'unique-token': 'Se asocia a un token único',
    'revocable': 'Puede revocarse en cualquier momento',
    'limited-access': 'Limita el acceso exclusivamente a la acción de firma autorizada',
    'otp-title': 'Verificación adicional del firmante (OTP)',
    'otp-intro': 'De forma configurable, BlueCMR permite exigir una verificación adicional antes de firmar, reforzando la identificación del firmante.',
    'otp-email': 'OTP por correo electrónico',
    'otp-email-desc': 'Código de verificación enviado al email del firmante',
    'otp-sms-title': 'OTP por SMS',
    'otp-sms-desc': 'Código de verificación enviado al teléfono móvil',
    'otp-conclusion': 'Esta verificación añade una capa adicional de seguridad y evidencia del control del canal utilizado por el firmante.',
    'biometric-title': 'Mecanismo de firma biométrica',
    'biometric-intro': 'En el proceso de firma manuscrita, BlueCMR captura y procesa información biométrica asociada al acto de firma:',
    'signature-strokes': 'Trazos de firma',
    'strokes-desc': 'Posición y tiempo',
    'dynamic-metrics': 'Métricas dinámicas',
    'metrics-desc': 'Velocidad, presión, aceleración',
    'signature-image': 'Imagen de firma',
    'image-desc': 'Representación visual',
    'biometric-data': 'Estos datos:',
    'encrypted-device': 'Se cifran en el dispositivo del firmante',
    'secure-processing': 'Se procesan de forma segura en el servidor',
    'linked-document': 'Se asocian de manera inequívoca al documento firmado',
    'biometric-note': 'La biometría no se utiliza con fines de identificación automática, sino como evidencia técnica que refuerza la autoría y la voluntad del firmante.',
    'evidence-title': 'Evidencias electrónicas generadas',
    'evidence-intro': 'Cada firma realizada en BlueCMR genera un conjunto de evidencias electrónicas:',
    'signer-identity': 'Identidad del firmante',
    'identity-desc': 'Nombre, email y documento de identidad, con constancia de si proceden del perfil de la empresa o fueron declarados al firmar',
    'document-role': 'Rol en el documento',
    'role-desc': 'Cargador, transportista, destinatario',
    'timestamp': 'Fecha y hora',
    'timestamp-desc': 'Timestamp preciso del acto de firma',
    'signature-context': 'Contexto de firma',
    'context-desc': 'Ubicación, zona horaria, dispositivo',
    'crypto-fingerprints': 'Huellas criptográficas',
    'fingerprints-desc': 'Hash del documento firmado',
    'express-acceptance': 'Aceptación expresa',
    'acceptance-desc': 'Consentimiento del acto de firma',
    'evidence-conclusion': 'Estas evidencias permiten reconstruir el acto de firma y demostrarlo ante terceros, autoridades o en procedimientos probatorios.',
    'forensic-title': 'Informe pericial bajo demanda',
    'forensic-p1': 'Ante una disputa, BlueCMR emite un informe de verificación de cualquier firma: comprueba la integridad de las evidencias, su sello criptográfico, el ejemplar exacto que firmó cada parte y el sello de tiempo. Cada comprobación es reproducible por un perito independiente.',
    'forensic-p2': 'Si un juzgado lo requiere, un procedimiento de custodia con doble control permite recuperar el trazo manuscrito y su dinámica para un análisis pericial, dejando registro de cada acceso.',
    'forensic-p3': 'El informe se entrega en PDF junto con un anexo técnico de reproducibilidad.',
    'pades-title': 'Firma en el documento (PAdES-LTV)',
    'pades-intro': 'Una vez completado el proceso, BlueCMR incorpora la firma al documento en formato PAdES con validación a largo plazo (LTV).',
    'pades-includes': 'El documento firmado incluye:',
    'pades-identity': 'Identidad del firmante',
    'pades-type': 'Tipo de firma electrónica utilizada',
    'pades-date': 'Fecha y ubicación de la firma',
    'pades-reference': 'Referencia a las evidencias electrónicas generadas',
    'pades-conclusion': 'El uso de sellado temporal y validación a largo plazo garantiza que la firma pueda verificarse en el futuro, incluso aunque los certificados hayan expirado.',
    'compliance-title': 'Cumplimiento normativo',
    'compliance-intro': 'Los mecanismos de firma implementados en BlueCMR permiten cumplir con:',
    'eidas': 'eIDAS',
    'eidas-desc': 'Firma electrónica avanzada (artículo 26)',
    'ecmr-protocol': 'Protocolo eCMR',
    'ecmr-desc': 'Integridad, identificación y consentimiento',
    'efti-frameworks': 'Marcos eFTI',
    'efti-desc': 'Documentos electrónicos de transporte',
    'spanish-regulation': 'Normativa española',
    'spanish-desc': 'Documentos de control y transporte',
    'compliance-conclusion': 'Las evidencias generadas son suficientes para demostrar la voluntad del firmante y la autoría del acto de firma, conforme a los requisitos legales aplicables.',
    'cta-title': '¿Tienes dudas sobre la firma electrónica?',
    'cta-subtitle': 'Nuestro equipo puede resolver tus preguntas sobre el proceso de firma y validez legal',
    'cta-button': 'Contactar con el equipo'
  },
  en: {
    'hero-title': 'Electronic Signature in BlueCMR',
    'hero-subtitle': 'Electronic signature is an essential element in the legal validity of digital transport documents. BlueCMR implements advanced electronic signature mechanisms, compliant with the eIDAS Regulation, that allow unequivocally linking identity, document and consent.',
    'intro': 'This page describes what type of signature BlueCMR uses, how the signature process is carried out and what technical and legal guarantees are applied.',
    'legal-title': 'Legal framework of electronic signature',
    'legal-intro': 'The eIDAS Regulation (EU 910/2014) establishes three types of electronic signature:',
    'simple-signature': 'Simple electronic signature',
    'advanced-signature': 'Advanced electronic signature',
    'qualified-signature': 'Qualified electronic signature',
    'bluecmr-uses': 'BlueCMR uses advanced electronic signature',
    'bluecmr-uses-desc': 'Suitable for digital transport documents compliant with eIDAS, the eCMR Protocol and applicable Spanish regulations.',
    'modalities-title': 'Signature modalities in BlueCMR',
    'modalities-intro': 'BlueCMR allows signing transport documents in different ways, adapting to the operational context of road transport.',
    'device-signature': 'Signature on own device',
    'device-signature-desc': 'The signer can perform the signature directly on their device, without intermediaries, with the signature linked to the document and their identity.',
    'third-party-signature': 'Signature sent to third parties',
    'third-party-signature-desc': 'A document can be sent for signature to:',
    'drivers': 'Drivers',
    'second-drivers': 'Second drivers',
    'transport-operators': 'Transport operators',
    'consignees': 'Consignees or other parties',
    'no-account-needed': 'The signature can be completed without needing to create an account on the platform.',
    'channels-title': 'Sending channels and authorization control',
    'channels-intro': 'When a document is sent for signature, BlueCMR generates a secure link that can be distributed through different channels:',
    'email': 'Email',
    'sms': 'SMS',
    'qr-code': 'QR Code',
    'whatsapp': 'WhatsApp',
    'link-features': 'Each signature link:',
    'unique-token': 'Is associated with a unique token',
    'revocable': 'Can be revoked at any time',
    'limited-access': 'Limits access exclusively to the authorized signature action',
    'otp-title': 'Additional signer verification (OTP)',
    'otp-intro': 'Configurably, BlueCMR allows requiring additional verification before signing, reinforcing signer identification.',
    'otp-email': 'OTP by email',
    'otp-email-desc': 'Verification code sent to signer\'s email',
    'otp-sms-title': 'OTP by SMS',
    'otp-sms-desc': 'Verification code sent to mobile phone',
    'otp-conclusion': 'This verification adds an additional layer of security and evidence of control of the channel used by the signer.',
    'biometric-title': 'Biometric signature mechanism',
    'biometric-intro': 'In the handwritten signature process, BlueCMR captures and processes biometric information associated with the signing act:',
    'signature-strokes': 'Signature strokes',
    'strokes-desc': 'Position and time',
    'dynamic-metrics': 'Dynamic metrics',
    'metrics-desc': 'Speed, pressure, acceleration',
    'signature-image': 'Signature image',
    'image-desc': 'Visual representation',
    'biometric-data': 'This data:',
    'encrypted-device': 'Is encrypted on the signer\'s device',
    'secure-processing': 'Is processed securely on the server',
    'linked-document': 'Is unequivocally associated with the signed document',
    'biometric-note': 'Biometrics are not used for automatic identification purposes, but as technical evidence that reinforces authorship and the signer\'s will.',
    'evidence-title': 'Electronic evidence generated',
    'evidence-intro': 'Each signature made in BlueCMR generates a set of electronic evidence:',
    'signer-identity': 'Signer identity',
    'identity-desc': 'Name, email and ID document, recording whether they come from the company profile or were declared at signing time',
    'document-role': 'Role in document',
    'role-desc': 'Shipper, carrier, consignee',
    'timestamp': 'Date and time',
    'timestamp-desc': 'Precise timestamp of signing act',
    'signature-context': 'Signature context',
    'context-desc': 'Location, time zone, device',
    'crypto-fingerprints': 'Cryptographic fingerprints',
    'fingerprints-desc': 'Hash of signed document',
    'express-acceptance': 'Express acceptance',
    'acceptance-desc': 'Consent of signing act',
    'evidence-conclusion': 'This evidence allows reconstructing the signing act and demonstrating it to third parties, authorities or in evidentiary proceedings.',
    'forensic-title': 'Forensic report on request',
    'forensic-p1': 'In the event of a dispute, BlueCMR issues a verification report for any signature: it checks the integrity of the evidence, its cryptographic seal, the exact copy each party signed and the timestamp. Every check can be reproduced by an independent expert.',
    'forensic-p2': 'If a court requires it, a dual-control custody procedure allows the handwritten stroke and its dynamics to be recovered for expert analysis, with every access recorded.',
    'forensic-p3': 'The report is delivered as a PDF together with a technical reproducibility annex.',
    'pades-title': 'Signature in document (PAdES-LTV)',
    'pades-intro': 'Once the process is completed, BlueCMR incorporates the signature into the document in PAdES format with long-term validation (LTV).',
    'pades-includes': 'The signed document includes:',
    'pades-identity': 'Signer identity',
    'pades-type': 'Type of electronic signature used',
    'pades-date': 'Date and location of signature',
    'pades-reference': 'Reference to generated electronic evidence',
    'pades-conclusion': 'The use of timestamping and long-term validation ensures that the signature can be verified in the future, even if certificates have expired.',
    'compliance-title': 'Regulatory compliance',
    'compliance-intro': 'The signature mechanisms implemented in BlueCMR allow compliance with:',
    'eidas': 'eIDAS',
    'eidas-desc': 'Advanced electronic signature (Article 26)',
    'ecmr-protocol': 'eCMR Protocol',
    'ecmr-desc': 'Integrity, identification and consent',
    'efti-frameworks': 'eFTI Frameworks',
    'efti-desc': 'Electronic transport documents',
    'spanish-regulation': 'National regulations',
    'spanish-desc': 'Transport documents',
    'compliance-conclusion': 'The generated evidence is sufficient to demonstrate the signer\'s will and authorship of the signing act, in accordance with applicable legal requirements.',
    'cta-title': 'Do you have questions about electronic signature?',
    'cta-subtitle': 'Our team can answer your questions about the signature process and legal validity',
    'cta-button': 'Contact the team'
  }
};
